import { CLIENT_URL } from '@shared/config/api/api';

import { AuthCodeResponse, GetAuthCodeForLoginReq } from '../../model/types/authCode';

export const getAuthCodeForLogin = async (data: GetAuthCodeForLoginReq): Promise<AuthCodeResponse> => {
  try {
    const res = await fetch(`${CLIENT_URL}/v2/auth/otp/send`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(data)
    });

    return await res.json();
  } catch (e) {
    console.error(e);
    throw e;
  }
};
